module.exports = __webpack_public_path__ + "static/media/AWRootbeerStandHuntingtonIN2005PencilandCoffeeonvintagepaper.8253dfdd.webp";